var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStadiumArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 18,
    viewBox: "0 0 40 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8492 8.30338L30.4771 1.881L31.5638 0.785767L39.7137 9.00005L31.5638 17.2143L30.4771 16.1191L36.6949 9.85228L0.285156 9.85228V8.30338L36.8492 8.30338Z",
    fill: "#23222F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStadiumArrow);
export default __webpack_public_path__ + "static/media/stadium_arrow.a444f6afbf4b1bc06b7f4480a3dc6092.svg";
export { ForwardRef as ReactComponent };